import dayjs from "dayjs";

import type { OrderLeadTimeValidationItem } from "./types";

export const indexLeadTimeResults = (
  items: OrderLeadTimeValidationItem[],
): Record<string, OrderLeadTimeValidationItem> =>
  items.reduce<Record<string, OrderLeadTimeValidationItem>>((result, item) => {
    result[item.product_code.trim().toLocaleLowerCase()] = item;
    return result;
  }, {});

export const getLeadTimeResult = (
  results: Record<string, OrderLeadTimeValidationItem>,
  productCode?: string | number,
): OrderLeadTimeValidationItem | undefined =>
  productCode == null
    ? undefined
    : results[String(productCode).trim().toLocaleLowerCase()];

export const buildLeadTimeErrorMessage = (
  item?: OrderLeadTimeValidationItem,
): string | undefined => {
  if (!item || item.is_valid !== false || !item.earliest_delivery_date) {
    return undefined;
  }
  const earliest = dayjs(item.earliest_delivery_date).format("YYYY/MM/DD");
  const leadTime = item.lead_time_days ?? 0;
  return `この商品は${earliest}以降の出荷日を選択してください。希望出荷日の${leadTime}日前までに注文が必要です。`;
};
